import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';

@Component({
	selector: 'app-ai-interview-limit-dialog-box',
	standalone: true,
	imports: [RouterModule],
	templateUrl: './ai-interview-limit-dialog-box.component.html',
	styleUrl: '../../globalStyle/limit-dialog-box-common.scss'
})
export class AiInterviewLimitDialogBoxComponent {


	constructor(
		private dialogRef: MatDialogRef<AiInterviewLimitDialogBoxComponent>,
		private router: Router
	) { }

	close() {
		this.dialogRef.close();
	}

	goToUpgradePlan() {
		this.router.navigate(['/student-dashboard/upgrade-plan']);
		this.close();
	}

}